(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-announcement"] && !Shopify.designMode) return;
  try {
    class DiscountAnnouncement extends HTMLElement {
    #timer = 0;
    #returnFocus = null;
    #dialogClickHandler = null;
    #dialogCloseHandler = null;

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-discount-popup-close]');
      if (!this.dialog) return;

      this.#dialogClickHandler = this.#handleDialogClick.bind(this);
      this.#dialogCloseHandler = this.#handleDialogClose.bind(this);
      this.dialog.addEventListener('click', this.#dialogClickHandler);
      this.dialog.addEventListener('close', this.#dialogCloseHandler);

      if (this.#isDesignMode() || !this.#hasSeenCampaign()) {
        const delay = this.#isDesignMode() ? 150 : Number(this.dataset.delayMs || 0);
        this.#timer = window.setTimeout(() => this.#open(), delay);
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.#timer);
      this.dialog?.removeEventListener('click', this.#dialogClickHandler);
      this.dialog?.removeEventListener('close', this.#dialogCloseHandler);
    }

    #isDesignMode() {
      return this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
    }

    #hasSeenCampaign() {
      try {
        return localStorage.getItem(this.dataset.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    #markCampaignSeen() {
      try {
        localStorage.setItem(this.dataset.storageKey, '1');
      } catch (error) {
        return;
      }
    }

    #open() {
      if (!this.isConnected || this.dialog.open) return;

      const activeDialog = document.querySelector('dialog[open]');
      if (activeDialog && activeDialog !== this.dialog) {
        this.#timer = window.setTimeout(() => this.#open(), 1000);
        return;
      }

      this.#returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      this.dialog.showModal();
      if (!this.#isDesignMode()) this.#markCampaignSeen();
      requestAnimationFrame(() => this.closeButton?.focus({ preventScroll: true }));
    }

    #handleDialogClick(event) {
      if (event.target === this.dialog || event.target.closest('[data-discount-popup-close]')) {
        this.dialog.close();
      }
    }

    #handleDialogClose() {
      if (this.#returnFocus?.isConnected && this.#returnFocus !== document.body) {
        this.#returnFocus.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('discount-announcement')) {
    customElements.define('discount-announcement', DiscountAnnouncement);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-specs"] && !Shopify.designMode) return;
  try {
    // ----- Scroll affordance: edge fade + one-time peek nudge -----
  const initSpecsScroll = (wrapper) => {
    if (wrapper.dataset.specsScrollInit) return;
    wrapper.dataset.specsScrollInit = 'true';

    const scroller = wrapper.querySelector('[data-specs-scroller]');
    const track = wrapper.querySelector('[data-specs-track]');
    if (!scroller || !track) return;

    const updateEdge = () => {
      const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
      wrapper.classList.toggle('is-at-end', atEnd);
    };
    scroller.addEventListener('scroll', updateEdge, { passive: true });
    updateEdge();

    const isScrollable = scroller.scrollWidth > scroller.clientWidth + 2;
    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!isScrollable || !isTouch || reducedMotion) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          obs.disconnect();
          setTimeout(() => track.classList.add('is-peeking'), 450);
        }
      },
      { threshold: 0.6 }
    );
    observer.observe(wrapper);
  };

  // ----- Metric → imperial swap for visitors in non-metric regions -----
  // Browsers don't expose a real "measurement system" preference, so
  // this uses the same locale-region heuristic as postal/shipping
  // tools: the US, Liberia and Myanmar are the only regions that use
  // imperial units day-to-day. Metric stays the server-rendered
  // default everywhere else, and for anyone without JS.
  const IMPERIAL_REGIONS = new Set(['US', 'LR', 'MM']);

  const prefersImperial = () => {
    const language = navigator.language || 'en-US';
    try {
      const region = new Intl.Locale(language).maximize().region;
      return IMPERIAL_REGIONS.has(region);
    } catch (error) {
      return /-US$/i.test(language);
    }
  };

  // factor converts FROM the metric unit TO the paired imperial unit.
  const METRIC_TO_IMPERIAL = {
    ml: { factor: 0.033814, unit: 'fl oz' },
    cl: { factor: 0.33814, unit: 'fl oz' },
    l: { factor: 33.814, unit: 'fl oz' },
    g: { factor: 0.035274, unit: 'oz' },
    kg: { factor: 2.20462, unit: 'lb' },
    mm: { factor: 0.0393701, unit: 'in' },
    cm: { factor: 0.393701, unit: 'in' },
    m: { factor: 39.3701, unit: 'in' },
  };

  const formatImperial = (value) => {
    // Light rounding: whole numbers once past single digits, one
    // decimal place below that so small values (e.g. 0.3 fl oz) don't
    // round away to nothing. Math.round already drops a trailing .0.
    const rounded = value >= 10 ? Math.round(value) : Math.round(value * 10) / 10;
    return String(rounded);
  };

  // Specs typed as free text ("18 cm", "26 x 21 cm") carry no measurement
  // metadata, so the value is parsed instead: one or more numbers sharing a
  // single trailing metric unit. Anything that doesn't match that exact shape
  // is left precisely as it was written — a half-understood dimension is
  // worse than an unconverted one.
  const TEXT_MEASUREMENT = /^([\d.,]+(?:\s*[x×]\s*[\d.,]+)*)\s*(mm|cm|m|ml|cl|l|g|kg)$/i;

  const convertTextMeasurement = (text) => {
    const match = text.trim().match(TEXT_MEASUREMENT);
    if (!match) return null;
    const conversion = METRIC_TO_IMPERIAL[match[2].toLowerCase()];
    if (!conversion) return null;
    const converted = [];
    for (const part of match[1].split(/\s*[x×]\s*/)) {
      const metricValue = parseFloat(part.replace(',', '.'));
      if (Number.isNaN(metricValue)) return null;
      converted.push(formatImperial(metricValue * conversion.factor));
    }
    return `${converted.join(' × ')} ${conversion.unit}`;
  };

  const convertSpecsToImperial = (root) => {
    for (const value of root.querySelectorAll('.product-specs__value:not([data-metric-value])')) {
      const converted = convertTextMeasurement(value.textContent);
      if (converted) value.textContent = converted;
    }
    for (const value of root.querySelectorAll('[data-metric-value]')) {
      const unit = (value.dataset.metricUnit || '').trim().toLowerCase();
      const conversion = METRIC_TO_IMPERIAL[unit];
      if (!conversion) continue; // already imperial, or an unrecognised unit — leave as-is
      const metricValue = parseFloat(value.dataset.metricValue);
      if (Number.isNaN(metricValue)) continue;
      const imperialValue = formatImperial(metricValue * conversion.factor);
      value.textContent = `${imperialValue} ${conversion.unit}`;
    }
  };

  const initProductSpecs = (root) => {
    for (const wrapper of root.querySelectorAll('.product-specs')) initSpecsScroll(wrapper);
    if (prefersImperial()) convertSpecsToImperial(root);
  };

  initProductSpecs(document);
  document.addEventListener('shopify:section:load', (event) => initProductSpecs(event.target));
  } catch(e) { console.error(e); }
})();

})();
